kv.controller('bdSourceTypeListCtrl', function ($element, $attrs, $scope, $injector) {
    return new dictionaryListCtrl($element, $attrs, $scope, $injector, {
        primaryKey: "bd_source_type_id",
        entity: "bd_source_type",
        modal: {
            templateUrl: "bd_source_type-edit",
            controller: "bdSourceTypeEditCtrl"
        }
    });
});
